module.exports = __webpack_public_path__ + "asset/img/cart-icon-has.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/cart-icon-has.svg
// module id = 843
// module chunks = 3 9